export default __webpack_public_path__ + "static/media/ps_photo.45cf485c.png";